import { StarIcon } from "icons";
import React from "react";
import { Heading, Text } from "ui-components";

interface IGoldBoxProps {
  isUserReachVisible?: boolean;
  isOrganizationProfileVisible?: boolean;
}

export function GoldBox({
  isUserReachVisible = false,
  isOrganizationProfileVisible = false,
}: IGoldBoxProps): JSX.Element {
  const starColor = isOrganizationProfileVisible ? "black" : "white";
  const starIcons = (
    <div className="flex gap-x-2.5 justify-center">
      {Array.from({ length: 4 }, (_, index) => (
        <StarIcon key={index} className={`w-4 h-4 text-${starColor}`} />
      ))}
    </div>
  );

  return (
    <div
      className={`${
        isOrganizationProfileVisible ? "w-full md:w-full" : "w-1/2 md:w-1/5"
      } p-[7px]`}
    >
      <div
        className={`w-full flex flex-col bg-[#FAC140] pt-5 ${
          isUserReachVisible ? "pb-5" : "pb-12"
        } px-4 items-center gap-y-3 ${
          isOrganizationProfileVisible ? "rounded-large" : "rounded-lg"
        }`}
      >
        {!isOrganizationProfileVisible && starIcons}
        <Heading
          className={`${
            isOrganizationProfileVisible ? "text-black" : "text-white"
          }`}
          variant="h3"
        >
          GOLD
        </Heading>
        {isOrganizationProfileVisible && starIcons}
        {isUserReachVisible && (
          <Text className="text-white text-center">20 MILLION REACH</Text>
        )}
      </div>
    </div>
  );
}
